<template>
  <ModalBase :show-modal="true" @close-modal="close" :auto-h="true" class="dashboard-promo-modal">
    <template v-slot:maincontent>
      <div style="padding: 2rem; text-align: center;">
        <div style="margin-bottom: 2rem;">
          <img src="/static/images/black-friday-logo-en.png" alt="" style="width: 250px; margin: 0 auto; display: block;">
        </div>
        <div>
          <h1>{{ $gettext('THIS FRIDAY = BLACK FRIDAY') }}</h1>
          <h2 style="margin-bottom: 1rem;">
            {{ $gettext('64,- discount to a yearly subscription Premium. More than 40% off.') }}
          </h2>
          <p style="font-size: 14px;" v-html="$gettext('Offer only for current Basic users. Existing Premium users are not eligible. Offer only available on the 25th for 24 hours until 12.00 PM. Discount only applies to Basic users upgrading to a yearly Premium account (additional users are excluded from offer).')">
          </p>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton"
export default {
  name: 'PromoModal',
  components: {
    ModalBase, TitleBar, GekkoButton
  },
  props: {

  },
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
    document.body.classList.add('modal-on');
  },
  methods: {
    close () {
      console.log('close modal')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  .dashboard-promo-modal {
    .gk-modal {
      padding: 0.5rem;
      max-width: 900px !important;
      .gk-modal-content {
        background: linear-gradient(103deg, #ce242f 43%, #8c1920 61%, black 78%);
        border-radius: $radiusMd;
        color: white;
        .modal-content-wrap { background: transparent; }
        .close-btn { top: 0; right: 0; }
      }
    }
  }
</style>
